import Vue from 'vue'
import Router from 'vue-router'
import Spash from './views/Splash'
import Intro from './views/Intro'
import Loading from './views/Loading'
import GameSelection from './views/GameSelection'
import TrueOrFalse from './views/Games/TrueOrFalse'
import NowYouSeeMe from './views/Games/NowYouSeeMe'
import HideAndSeek from './views/Games/HideAndSeek'
import AvatarGenerator from './views/AvatarGenerator'
import Wallet from './views/Wallet'
import FactCards from './views/Cards/FactCards'
import FactCard from './views/Cards/FactCard'
import FactFiles from './views/Cards/FactFiles'
import FactFile from './views/Cards/FactFile'
import LeaderBoard from './views/LeaderBoard'
import GameScore from './views/GameScore'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Splash',
      component: Spash
    },
    {
      path: '/avatar',
      name: 'AvatarGenerator',
      component: AvatarGenerator
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/loading',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/selection',
      name: 'GameSelection',
      component: GameSelection
    },
    {
      path: '/true-or-false',
      name: 'TrueOrFalse',
      component: TrueOrFalse
    },
    {
      path: '/now-you-see-me',
      name: 'NowYouSeeMe',
      component: NowYouSeeMe
    },
    {
      path: '/hide-and-seek',
      name: 'HideAndSeek',
      component: HideAndSeek
    },
    {
      path: '/wallet',
      name: 'Wallet',
      component: Wallet
    },
    {
      path: '/fact-cards',
      name: 'FactCards',
      component: FactCards
    },
    {
      path: '/fact-card/:id',
      name: 'FactCard',
      component: FactCard,
      props: true
    },
    {
      path: '/fact-files',
      name: 'FactFiles',
      component: FactFiles
    },
    {
      path: '/fact-file/:id',
      name: 'FactFile',
      component: FactFile,
      props: true
    },
    {
      path: '/leaderboard',
      name: 'LeaderBoard',
      component: LeaderBoard
    },
    {
      path: '/game-score',
      name: 'GameScore',
      component: GameScore
    }
  ]
})
